import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { serverDomain } from "../../config";
import "./login.css";

const Header = () => {
    return (
        <header className="header">
            <div className="logo">
                <span>Fl-Dating</span>
            </div>
        </header>
    );
};

const LoginForm = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const reason = params.get("reason");

    const notice =
    reason === "blocked"
      ? "Вы были заблокированы. Обратитесь в поддержку - @fl_assistance"
      : reason === "expired"
      ? "Сессия истекла. Пожалуйста, войдите снова."
      : reason === "forbidden"
      ? "Что-то пошло не так. Пожалуйста, авторизуйтесь снова."
      : reason === "registration_success"
      ? "Заявка отправлена. Для быстрого одобрения обязательно напишите в ТП @fl_assistance."
      : "";

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Отправка запроса на сервер для входа
            const response = await fetch(serverDomain +"/api/auth/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email, password }),
            });

            if (response.ok) {
                const data = await response.json();
                localStorage.setItem('isAuthenticated', true);
                localStorage.setItem("token", data.token);
                navigate('/');
            } else {
                const errorData = await response.json();
                setPassword("")
                setError(errorData.message || "Ошибка входа");
            }
        } catch (err) {
            if (err.response?.status === 401) {
                alert("Сессия истекла. Пожалуйста, войдите заново.");
                localStorage.removeItem("token");
                localStorage.removeItem("isAuthenticated");
                window.location.href = "/login";
            }
            else {
                setError("Ошибка подключения к серверу");
            }
        }
    };

    const handleCreateAccount = () => {
        navigate("/register"); // Переход на страницу регистрации
    };

    const handleResetPassword = () => {
        navigate("/reset-password"); // Переход на страницу запроса сброса пароля
    };

    return (
        <div className="login-container">
            <h2 style={{fontWeight: "bold", marginBottom: "12px", fontSize: "20px"}}>Войдите</h2>
            <form onSubmit={handleSubmit}>
                <input
                    type="email"
                    placeholder="E-mail"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <input
                    type="password"
                    placeholder="Пароль"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                {error && (
                <p style={{ color: "red" }} className="error">
                    {error}
                </p>
                )}

                <div className="auth-actions">
                <button type="submit" className="auth-actions__login">
                    Войти
                </button>

                <button
                    type="button"
                    className="secondary"
                    onClick={handleCreateAccount}
                >
                    Создать аккаунт
                </button>
                </div>

                {!error && notice && (
                    <p className="auth-notice">
                        {notice}
                    </p>
                )}


                <div className="links">
                    <a onClick={handleResetPassword}>Восстановление пароля</a>
                </div>
            </form>
        </div>
    );
};


const App = () => {
    return (
        <div className="auth-page">
            <Header />
            <LoginForm />
        </div>
    );
};

export default App;
